import { Component, Input } from '@angular/core';

/**
 * `<app-submission-extra-fields-display>` — apresentação READ-ONLY dos
 * campos adicionais (Variação B: rótulo em cima + valor(es) embaixo).
 * Passo 6 da migração pra `<app-submission-export-view>`.
 *
 * Recebe as respostas já processadas pelo paper-info (getter
 * `extraFieldAnswers` = filtragem de vazios + sort por `order`). Edit-mode
 * permanece INLINE no paper-info (pílulas clicáveis, editores por tipo,
 * `FormGroup` local — nada disso faz sentido reutilizar aqui).
 */
@Component({
  selector: 'app-submission-extra-fields-display',
  templateUrl: './submission-extra-fields-display.component.html',
  styleUrls: ['./submission-extra-fields-display.component.scss'],
})
export class SubmissionExtraFieldsDisplayComponent {
  /** Array de respostas: `{ shortLabel, required, description, options?, answers? }`.
   *  Vazio ou null = nada renderiza (paper-info controla o wrapper via
   *  `*ngIf="hasExtraFields"`; aqui defendemos com `*ngIf` interno também). */
  @Input() extraFieldAnswers: any[] = [];
}
